// extracted by mini-css-extract-plugin
export var aiStarIcon = "_ap-4";
export var closeButton = "_ap-6";
export var dismissButton = "_ap-3";
export var editImageWithAiContainer = "_ap-8";
export var imageUploadWrapper = "_ap-7";
export var misspelledWord = "_ap-5";
export var spellCheckContainer = "_ap-2";
export var spin = "_ap-1";
export var spinning = "_ap-0";